module.exports = __webpack_public_path__ + "img/guide3.bc5d9af2.png";